




























































































































































































































































import { getImagePaths, addLocalCurrency } from '@/utils/general'
import OImage from '@/components/OImage'
import OButton from '@/components/OButton'
import OSvg from '@/components/OSvg'
import Faq from '@/components/Faq'
import AddressFormat from '@/components/AddressFormat'
import OSelect from '@/components/OSelect'
import NewButton from '@/components/NewButton'
import CreateAccountForm from '@/components/Forms/CreateAccountForm'
import UndershirtsSizeModal from '@/components/Undershirts/UndershirtsSizeModal'
import AddressForm from '@/components/Forms/AddressForm'
import { SocksDiscountPrices, UndershirtsDiscountPrices, UndershirtsPrices } from '@/enums/products'
import { idPrefixes } from '@/enums/signup'
import { CREATE_MEMBER_ON_LANDINGPAGE } from '@/utils/store/actionTypes'
import { CountryNames, Currencies } from '@/enums/general'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { SET_REDIRECT_URL } from '@/utils/store/mutationTypes'
import { IS_AUTHENTICATED, AUTH_USER } from '@/utils/store/getterTypes'
import { MembershipTypes } from '@/enums/member'

type SocksDiscountPricesType = typeof SocksDiscountPrices
type CurrenciesType = typeof Currencies

const sizeOptions = [
  {
    value: 208,
    label: 'XS'
  },
  {
    value: 209,
    label: 'S'
  },
  {
    value: 210,
    label: 'M'
  },
  {
    value: 211,
    label: 'L'
  },
  {
    value: 212,
    label: 'XL'
  },
  {
    value: 213,
    label: 'XXL'
  },
  {
    value: 214,
    label: '3XL'
  }
]

export default {
  name: 'Undershirts',
  layout: 'homepage',
  components: { OImage, OButton, OSvg, Faq, AddressFormat, CreateAccountForm, AddressForm, OSelect, NewButton, UndershirtsSizeModal },
  data () {
    return {
      form: {
        userId: '',
        firstName: '',
        lastName: '',
        email: '',
        annex: '',
        area: '',
        country: '',
        building: '',
        city: '',
        floor: '',
        hash: '',
        houseNumber: '',
        postalCode: '',
        region: '',
        street: '',
        streetType: '',
        countryCode: ''
      },
      productGroupSizeLabel: sizeOptions[0].label,
      errors: {},
      consent: false,
      isEditing: false,
      invalidData: false,
      loading: false,
      success: false,
      loadingConfirmation: false,
      street: ''
    }
  },
  computed: {
    faqItems () {
      const path = 'LandingsPage.Undershirts.FAQ.Items'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, index) => ({
        title: this.$t(`${path}[${index}].Title`, this.variables),
        description: this.$t(`${path}[${index}].Description`, this.variables)
      }))
    },
    usps () {
      const path = 'LandingsPage.Undershirts.SneakerFreakBlock.USPS'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      return items.map((_, index) => this.$t(`${path}[${index}]`, this.variables))
    },
    faqLink () {
      return `<a class="underline" href="/faq" target="_blank" rel="noopener noreferrer">${this.$t('LandingsPage.Undershirts.FAQ.Here')}</a>`
    },
    slides () {
      const items = this.$t('LandingsPage.Undershirts.ComfortableSocks.Slides')

      if (!Array.isArray(items)) {
        return []
      }

      return items
    },
    displayAddress () {
      const address = { ...this.form, country: this.$t(`Countries.${this.country}`) }

      if (!this.isEditing) {
        return {
          ...address,
          street: this.displayStreet
        }
      }

      return address
    },
    productGroupSizeId () {
      return this.sizeOptions.find((sizeOption: { label: string }) => sizeOption.label === this.productGroupSizeLabel).value
    },
    displayStreet () {
      return this.street.replace(/,/g, ', ')
    },
    sizeOptions () {
      return sizeOptions
    },
    variables () {
      const currencyKey: keyof CurrenciesType = this.country

      return {
        undershirtsPrice: addLocalCurrency(UndershirtsPrices[this.country as keyof typeof UndershirtsPrices], `${this.locale}-${this.country.toUpperCase()}`, Currencies[currencyKey]),
        undershirtsDiscountPrice: addLocalCurrency(UndershirtsDiscountPrices[this.country as keyof typeof UndershirtsDiscountPrices], `${this.locale}-${this.country.toUpperCase()}`, Currencies[currencyKey]),
        link: this.faqLink
      }
    },
    steps () {
      const items: any = this.$t('LandingsPage.Undershirts.Form.Steps')

      if (!Array.isArray(items)) {
        return []
      }

      return items
    },
    country (): keyof SocksDiscountPricesType {
      if (Object.keys(CountryNames).includes(this.form.countryCode)) {
        return this.form.countryCode
      }

      return this.appCountry
    },
    price () {
      const currencyKey: keyof CurrenciesType = this.country
      return addLocalCurrency(UndershirtsPrices[this.country as keyof typeof UndershirtsPrices], `${this.locale}-${this.country.toUpperCase()}`, Currencies[currencyKey])
    },
    ...mapGetters('auth', {
      isAuthenticated: IS_AUTHENTICATED,
      authUser: AUTH_USER
    }),
    ...mapState<{ country: keyof SocksDiscountPricesType, locale: string }>('app', {
      appCountry: (state: { country: keyof SocksDiscountPricesType, locale: string }) => state.country,
      locale: (state: { country: keyof SocksDiscountPricesType, locale: string }) => state.locale
    })
  },
  watch: {
    invalidData: {
      handler (newInvalidData: boolean) {
        if (newInvalidData) {
          if (!this.isAuthenticated) {
            const url = `${this.$route?.fullPath.replace(new RegExp('/\\w\\w-\\w\\w'), '')}`

            this.setRedirectUrl({ url })

            this.$router.push(this.$i18n.localePath({ name: 'login' }))
          } else {
            this.form.userId = this.authUser.user._id
            this.form.firstName = this.authUser.firstName
            this.form.lastName = this.authUser.lastName
            this.form.email = this.authUser.email
            this.form.country = this.authUser.user.billingAddress.country.name.toLowerCase()
            this.form.city = this.authUser.user.billingAddress.city
            this.form.postalCode = this.authUser.user.billingAddress.postalCode
            this.form.countryCode = this.authUser.user.billingAddress.country.name.toLowerCase() || 'nl'

            this.street = this.authUser.user.billingAddress.fullStreet
          }
        }
      }
    }
  },
  created () {
    try {
      const data = JSON.parse(decodeURIComponent(atob(this.$route.query.data)))

      if (!data.id || !data.email) {
        this.invalidData = true
      }

      this.form.userId = data.id
      this.form.firstName = data.firstName
      this.form.lastName = data.lastName
      this.form.email = data.email
      this.form.country = data.address.country
      this.form.city = data.address.city
      this.form.postalCode = data.address.postalCode
      this.form.countryCode = data.country ? data.country.toLowerCase() : 'nl'

      this.form.hash = data.campaign_hash

      this.street = data.address.street
    } catch (error) {
      this.invalidData = true
    }
  },
  methods: {
    onSizeChartButtonClick () {
      this.$refs.undershirtsSizeModal.toggleActivation()
    },
    getImagePaths (path: string) {
      return getImagePaths({
        path: `/images/frontend/undershirts/${path}`,
        s3: true
      })
    },
    onNameChange ({ value, field }: { value: string, field: string }) {
      this.form[field] = value
    },
    onAddressChange ({ field, address }: { field: string, address: any }) {
      this.form[field] = address[field]
    },
    async onSubmit () {
      this.loading = true

      if (this.isEditing) {
        this.$refs.createAccountForm.$v.$touch()
        this.$refs.addressForm.$v.$touch()

        if (this.$refs.addressForm.$v.$invalid || this.$refs.createAccountForm.$v.$invalid) {
          if (this.$refs.addressForm.$v.$invalid) {
            this.$refs.addressForm.invalidForm = true
          }

          if (this.$refs.createAccountForm.$v.$invalid) {
            this.$refs.createAccountForm.invalidForm = true
          }

          this.$otoaster.danger(this.$t('Form.Error.RequiredFields'))

          this.loading = false
          return
        }
      }

      try {
        const variables = {
          user: `${idPrefixes.user}${this.form.userId}`,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          productGroupSize: `/api/product_group_sizes/${this.productGroupSizeId}`,
          differentDeliveryAddress: this.isEditing,
          membershipTypeReference: MembershipTypes.undershirts,
          userValidationHash: this.form.hash,
          address: {
            houseNumberAddition: this.form.annex,
            area: this.form.area,
            building: this.form.building,
            city: this.form.city,
            floor: this.form.floor,
            houseNumber: this.form.houseNumber,
            postalCode: this.form.postalCode,
            region: this.form.region,
            street: this.form.street,
            streetType: this.form.streetType
          }
        }
        await this.createMember(variables)

        this.scrollToForm()
        this.success = true
      } catch (error: any) {
        const errors = this.$ota.general.getCustomErrorMessages(error)

        if (errors.messages && Object.keys(errors.messages).length) {
          const formattedErrors = Object.keys(errors.messages).reduce((acc, key) => ({
            ...acc,
            ...(key.includes('address.') ? {
              [key.replace('address.', '')]: errors.messages[key]
            } : {
              [key]: errors.messages[key]
            })
          }), {})

          this.errors = formattedErrors
        } else {
          this.$ota.general.logError(error)
          const graphQLError = error.graphQLErrors.find((error: any) => error.hasOwnProperty('message'))?.message
          this.$otoaster.danger(graphQLError || this.$t('Socks.LandingsPage.ErrorDescription'))
        }
      }

      this.loading = false
    },
    scrollToForm () {
      try {
        this.$refs?.signupForm.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      } catch (error) {}
    },
    ...mapMutations('auth', {
      setRedirectUrl: SET_REDIRECT_URL
    }),
    ...mapActions('member', {
      createMember: CREATE_MEMBER_ON_LANDINGPAGE
    })
  }
}
